import { computed, effect, signal } from "@preact/signals-react";
const LOCAL_STORAGE_KEY = "refresher-menu";

export const getRefresherFromLocalStorage = () => {
  const shouldRefresh = localStorage.getItem(LOCAL_STORAGE_KEY);
  return shouldRefresh ? Boolean(shouldRefresh) : null;
};

export const setRefresherToLocalStorage = (status) => {
  localStorage.setItem(LOCAL_STORAGE_KEY, status);
};

export const refresherSignal = signal(getRefresherFromLocalStorage());

effect(() => {
  setRefresherToLocalStorage(refresherSignal.value);
});
